module.exports = __webpack_public_path__ + "static/media/jp.pictogram.9825366e.svg";